export const addDotToEnd = (value: string): `${string}.` => `${value}.`
